import { request } from "react-rb/request"

/**
 * Updates the account's brand settings.
 *
 * @param {Object} params
 * @param {string} params.faviconUrl - The favicon URL to save on the brand
 * @return {Promise<Object>} The updated brand attributes
 */
export async function updateBrand({ faviconUrl }) {
  const response = await request("/account/brand", {
    method: "PUT",
    data: { brand: { favicon_url: faviconUrl } }
  })
  if (!response.ok) throw response
  return response.data
}

export async function fetchBrandColors() {
  const response = await request("/account/color_settings", {
    method: "GET",
    autoRedirect: false
  })
  if (!response.ok) return []
  return response.data?.colors ?? []
}

export async function updateBrandColors(colors) {
  const response = await request("/account/color_settings", {
    method: "PUT",
    data: { colors_settings: { colors } }
  })
  if (!response.ok)
    throw new Error(response.data?.errors || "Couldn't save colors")
  return response.data.colors
}

export async function fetchBrandFonts(type) {
  const params = new URLSearchParams({ type })
  const response = await request(`/account/brand_fonts?${params}`, {
    method: "GET",
    autoRedirect: false
  })
  if (!response.ok) return []
  return response.data?.brand_fonts ?? []
}

export async function createBrandFont({ label, emailSafe, fileUrl, source }) {
  const response = await request("/account/brand_fonts", {
    method: "POST",
    data: {
      brand_font: { label, email_safe: emailSafe, file_url: fileUrl },
      source
    }
  })
  if (!response.ok)
    throw new Error(response.data?.errors || "Couldn't save font")
  return response.data.brand_font
}

export async function destroyBrandFont({ id, source }) {
  const url = `/account/brand_fonts/${id}?source=${source}`
  const response = await request(url, { method: "DELETE" })
  if (!response.ok)
    throw new Error(response.data?.errors || "Couldn't remove font")
}
